import { TAppVersion, TVersion } from 'api/types';

export const versionData: TVersion = {
  version: '1',
  stand: TAppVersion.PROD,
};
